/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';

// actions
import { updatePageDetails, changePage, displayMessage, displayModal } from '@insticator/insticator-ui';
import { updateUserStatus } from 'state/actions/user_status';
import { signOut, unmockUser, redirectToMockupGenerator } from 'state/actions/auth_status';

// compontent
import Header from 'material/structure/header/header';



/* ========== ~~~~~~~~~~ STRUCTURE : HEADER : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, sessionStatus }) => ({
    currentPage: appStatus.currentPage,
    userFirstName: sessionStatus.userFirstName,
    editMode: appStatus.editMode,
    mocked: sessionStatus.mocked,
    mockupGenerator: sessionStatus.mockupGenerator,
    mockupGeneratorSource: sessionStatus.mockupGeneratorSource,
    siteUUID: sessionStatus.siteUUID,
    reportsPermitted: sessionStatus.permissions.includes('home.adMetrics'),
    accountSettingsPermitted: sessionStatus.mocked || sessionStatus.permissions.includes('settings.general') ||
        sessionStatus.permissions.includes('settings.adsTxt') || sessionStatus.permissions.includes('settings.paymentInfo') ||
        sessionStatus.permissions.includes('settings.sites') || sessionStatus.permissions.includes('setttings.sites') || sessionStatus.permissions.includes('settings.users'),
});
// map actions
const mapDispatchToProps = dispatch => ({
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    },
    displayMessage: message => dispatch(displayMessage(message)),
    displayModal: (isVisible, contentToDisplay, showCloseButton) => dispatch(displayModal(isVisible, contentToDisplay, showCloseButton)),
    signOut: () => dispatch(signOut()),
    unmockUser: () => dispatch(unmockUser()),
    updateUserStatus: value => dispatch(updateUserStatus(value)),
    redirectToMockupGenerator: (siteUUID, source) => dispatch(redirectToMockupGenerator(siteUUID, source))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);
